import React, {useEffect, useState} from "react";
import {Box, Card, Drawer, Snackbar} from "@mui/material";
import {customDirectives, getLesetextWithMarkedSentencenr} from "../utils/utils";
import directive from "remark-directive";
import gfm from 'remark-gfm';
import ReactMarkdown from "react-markdown";
import {SingleExerciseComponent} from "./SingleExerciseComponent";

export default function MultipleExerciseComponent(props) {
    const [state, setState] = useState(false);
    const [myfeedbackmode, setMyfeedbackmode] = useState('mode_feedback')
    const [currentExercise, setCurrentExercise] = useState(false);
    const toggleDrawer = (open, exercise) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        if (exercise) {
            setCurrentExercise(exercise)
        }
        setState(open);
    };

    function handleToggleDrawLesetext(exercise) {
        return toggleDrawer(true, () => {
            return (
                <ReactMarkdown
                    components={{}}
                    remarkPlugins={[directive, gfm, customDirectives,]}
                >
                    {getLesetextWithMarkedSentencenr(props.lesetext, exercise.sentencenr)}
                </ReactMarkdown>
            )
        });
    }

    function handleToggleDrawHilfe(exercise) {
        return toggleDrawer(true, () => {
            return (
                <div>
                    <pre>Hier kommt die Hilfe</pre>
                    <p>Sie muss noch geschrieben werden.</p>
                </div>
            )
        })

    }

    function handleToggleDrawJSON(exercise) {
        return toggleDrawer(true, () => {
            return (
                <pre style={{whiteSpace: 'pre-wrap'}}>{JSON.stringify(exercise, null, 2)}</pre>
            )
        });
    }

    function handleToggleFeedbackmode() {
        if (myfeedbackmode == 'mode_normal') {
            setMyfeedbackmode('mode_feedback')
            // setTimeout(() => {
            //     setMyfeedbackmode('mode_normal')
            //     handleSnackbarOpen();
            // }, 20000);
        } else {
            setMyfeedbackmode('mode_normal')
        }
    }

    useEffect(() => {
        // console.log(myfeedbackmode)
    }, [myfeedbackmode]);

    const [snackbarOpen, setSnackbarOpen] = useState(false)

    function handleSnackbarOpen(event, reason) {
        setSnackbarOpen(true)
    }

    function handleSnackbarClose(event, reason) {
        setSnackbarOpen(false)
    }

    return (
        <Box>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                message="Feedback Modus nach 20sec. automatisch beendet. Schalten Sie es bei Bedarf wieder ein."
                // action={action}
            />
            {/*<pre>exerciseList = {JSON.stringify(props.exerciseList, null, 2)}</pre>*/}
            {
                props.exerciseList.filter(
                    e => !['?', 'sectionbegin', 'sectionend'].includes(e.type)
                ).map(
                    (exercise, index) => {
                        index = index + 1;
                        return (
                            <SingleExerciseComponent key={index.toString()}
                                                     value={exercise}
                                                     index={index}
                                                     lesetext={props.lesetext}
                                                     feedbackMode={myfeedbackmode}
                                                     onToggleDrawHilfe={handleToggleDrawHilfe()}
                                                     onToggleDrawLesetext={handleToggleDrawLesetext(exercise)}
                                                     onToggleDrawJSON={handleToggleDrawJSON(exercise)}
                                                     onToggleFeedbackmode={handleToggleFeedbackmode}
                            />
                        )
                    }
                )
            }
            <Drawer anchor="right" BackdropProps={{style: {backgroundColor: '#eee', opacity: 0.5}}} open={state}
                    onClose={toggleDrawer(false)}>
                <Box
                    sx={{
                        width: '80vw',
                        padding: '3px',
                    }}
                    // role="presentation"
                    onClick={toggleDrawer(false)}
                    onKeyDown={toggleDrawer(false)}
                >
                    <Card elevation={3}
                          sx={{padding: '0 1em 1em 1em', margin: '0', backgroundColor: '#fff',}}
                          square={true}>
                        {/*<pre*/}
                        {/*    style={{whiteSpace: 'pre-wrap'}}>Lorem ipsum {JSON.stringify(currentExercise, null, 2)}</pre>*/}
                        {currentExercise}
                        {/*<SampleText/>*/}

                    </Card>
                </Box>
            </Drawer>
        </Box>
    );
}
